import React from 'react';
import cn from 'classnames';
import { useTheme } from '@repo/themes';
import sourceIconPaths from '@repo/utils/helpers/source-icon-paths';

export function Badge({ src, icon = false, ...props }) {
  props.className = cn('badge', icon ? 'badge-icon' : null, props.className);

  return <img {...props} src={src} />;
}

export function InteractionTypeBadge({ interaction = null }) {
  const [_, themeFamily] = useTheme();

  if (!interaction) {
    return null;
  }

  const imageKey = `${interaction}_${themeFamily}`;

  return <Badge src={sourceIconPaths[imageKey] || sourceIconPaths[interaction]} icon />;
}
